<div class="row form-group">
  <div class="col-sm-12">
    <div class="card">
      <div class="card-body">
        <h2 class="card-title">Facilities: Request Parking Passes</h2>
      </div>
    </div>
  </div>
</div>
<form #parkingForm="ngForm" (ngSubmit)="onSubmit(parkingForm)" class="form-group">
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <div class="card">
        <div class="card-body">
          <p class="card-title"><strong>Contact Preference</strong></p>
          <person-type-ahead class="form-typeahead"
            [(container)]="peopleService"
            field="typeaheadQuery"
            labelText="Additional Contact"
            [labelCols]="3"
            [searchResults$]="personTypeaheadResults$"
            [noFocusHide]="true"
            (returnSearchString)="triggerSearch($event)"
            (returnSelectedPerson)="selectPerson($event)">
          </person-type-ahead>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <div class="card">
        <div class="card-body">
          <p class="card-title"><strong>Distribution Preference</strong></p>
          <editable-radio-button-field (returnInput)="validate()" [(container)]="ParkingForm" field="choice" [id]="'rbFacilities'" value="facilities" [labelText]="'Facilities will send individual passes to all guests'"></editable-radio-button-field>
          <editable-radio-button-field (returnInput)="validate()" [(container)]="ParkingForm" field="choice" [id]="'rbRequester'" value="requester" [labelText]="'I prefer to send passes to all guests'"></editable-radio-button-field>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-body">
          <p class="card-title"><strong>Start Date And Time</strong></p>
          <editable-date [placement]="'bottom'" (returnInput)="validate()" [(container)]="ParkingForm" field="startDate" [labelText]="'Start Date'" [labelCols]="3" [placeholder]="''"></editable-date>
          @if (ParkingForm.timeList.length > 0) {
            <editable-dropdown (returnInput)="validate()" [(container)]="ParkingForm" field="startTimeData" [labelText]="'Start Time'" [listObject]="ParkingForm.timeList" [labelCols]="3" [placeholder]="'Select A Time'" [useValueAsKey]="true"></editable-dropdown>
          }
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-body">
          <p class="card-title"><strong>End Date And Time</strong></p>
          <editable-date [placement]="'bottom'" (returnInput)="validate()" [(container)]="ParkingForm" field="endDate" [labelText]="'End Date'" [labelCols]="3" [placeholder]="''"></editable-date>
          @if (ParkingForm.timeList.length > 0) {
            <editable-dropdown (returnInput)="validate()" [(container)]="ParkingForm" field="endTimeData" [labelText]="'End Time'" [listObject]="ParkingForm.timeList" [labelCols]="3" [placeholder]="'Select A Time'" [useValueAsKey]="true"></editable-dropdown>
          }
        </div>
      </div>
    </div>
  </div>

  @if (ParkingForm.choice == 'requester') {
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <p class="card-title"><strong>Group Parking Permits</strong></p>
            <editable-number-field (returnInput)="validate()" [placeholder]="0" [(container)]="ParkingForm" field="numberOfPermits" [labelText]="'Number of Parking Passes'" [labelCols]="4"></editable-number-field>
            <editable-text-area (returnInput)="validate()" [(container)]="ParkingForm" field="reason" [labelText]="'Please provide the guest or event name and any applicable details.'" [placeholder]="''" [labelCols]="4"></editable-text-area>
          </div>
        </div>
      </div>
    </div>
  }

  @if (ParkingForm.choice == 'facilities') {
    <div class="row">
      <div class="col-sm-12">
        <p><strong>Permits</strong></p>
        <div class="table-responsive-md">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Action</th>
                <th>Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              @for (dynamic of permitsArray; track $index; let i = $index) {
                <tr>
                  <td>
                    <button type="button" class="btn btn-danger" aria-label="Delete Person" title="Remove Current Row" (click)="deleteRow(i)"><i class="fa fa-trash"></i><span class="sr-only">Delete Row</span></button>
                  </td>
                  <td>
                    <input [(ngModel)]="permitsArray[i].Name" title="Name" id="name{{i}}" name="name{{i}}" type="text" (change)="validate()" (blur)="validate()" />
                    @if (ParkingForm.nameErrors['name' + i]) {
                      <div class="alert alert-danger"><i class="fas fa-exclamation-triangle text-danger"></i><span> {{ParkingForm.nameErrors['name' + i]}}</span></div>
                    }
                  </td>
                  <td>
                    <input [(ngModel)]="permitsArray[i].Email" title="Email" id="email{{i}}" name="email{{i}}" type="email" (change)="validate()" (blur)="validate()" />
                    @if (ParkingForm.emailErrors['email' + i]) {
                      <div class="alert alert-danger"><i class="fas fa-exclamation-triangle text-danger"></i><span> {{ParkingForm.emailErrors['email' + i]}}</span></div>
                    }
                    @if (ParkingForm.emailErrors['badEmail' + i]) {
                      <div class="alert alert-danger"><i class="fas fa-exclamation-triangle text-danger"></i><span> {{ParkingForm.emailErrors['badEmail' + i]}}</span></div>
                    }
                  </td>
                </tr>
              }
              <tr>
                <td>
                  <button type="button" class="btn btn-success" aria-label="Add Person" title="Add New Person" (click)="addRow(i)"><i class="fa fa-plus"></i><span class="sr-only">Add</span></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  }
  @if (objectKeys(ParkingForm.errors).length > 0 && objectKeys(ParkingForm.touched).length > 0) {
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Errors Summary</h4>
        @for (error of objectEntries(ParkingForm.errors); track $index) {
          <p class="alert alert-danger"><i class="fas fa-exclamation-triangle text-danger mr-1"></i><span>{{error[1]}}</span></p>
        }
      </div>
    </div>
  }
  <div class="row form-group">
    <div class="col-sm-12">
      <button [disabled]="objectKeys(ParkingForm.errors).length > 0 || submittingToServer" class="btn btn-primary" type="submit">
        Submit@if (submittingToServer) {
        <span><i class="fas fa-circle-notch fa-spin"></i></span>
      }
    </button>
    <button class="btn btn-outline-secondary" type="button" style="margin-left: 5px" (click)="close()" [disabled]="submittingToServer">
      Cancel
    </button>
  </div>
</div>
</form>
